import { resolveObjPathString } from "src/utils/resolve-path";

export const resolveName = (name, context) => {
    if (!name) return name;
    if (!name.includes("$")) return name;
    const matches = Array.from(name.matchAll(/\$[a-zA-Z-_.]*/g));
    let finalName = name;
    matches.forEach((matchGroup) => {
        const [match] = matchGroup as string[];
        const value = resolveObjPathString(context, match.replace("$", ""));
        if (value) {
            finalName = finalName.replaceAll(match, value);
        }
        finalName = finalName.replaceAll(match, "...");
    });
    return finalName;
};

export const test = 1;
